import { render, staticRenderFns } from "./showDetails.vue?vue&type=template&id=36c13745&scoped=true&"
import script from "./showDetails.vue?vue&type=script&lang=js&"
export * from "./showDetails.vue?vue&type=script&lang=js&"
import style0 from "./showDetails.vue?vue&type=style&index=0&id=36c13745&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c13745",
  null
  
)

export default component.exports